var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRestaurant = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19081_1040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5837 21.6039L17.3098 15.33L9.97981 8H9.40697L9.29 8.29722C8.98128 9.08172 8.84937 9.88409 8.90859 10.6175C8.97609 11.4535 9.29368 12.1773 9.82709 12.7107L15.5493 18.4329L16.304 17.6781L21.5942 23.5935C22.1204 24.1198 23.0262 24.151 23.5837 23.5935C24.1323 23.045 24.1323 22.1525 23.5837 21.6039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8979 17.1075L8.41626 21.5891C7.86776 22.1376 7.86776 23.0302 8.41626 23.5787C8.93732 24.0997 9.83873 24.1457 10.4058 23.5787L14.8874 19.097L12.8979 17.1075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3203 10.664L20.7781 13.2062L20.1149 12.543L22.6571 10.0008L21.9939 9.33757L19.4517 11.8798L18.7885 11.2166L21.3308 8.67439L20.6676 8.01123L17.3517 11.3272C16.946 11.7328 16.7038 12.2714 16.6695 12.8439C16.6609 12.9889 16.628 13.1316 16.5735 13.2673L18.7275 15.4213C18.8632 15.3667 19.0059 15.3339 19.1509 15.3252C19.7233 15.291 20.262 15.0488 20.6676 14.6431L23.9835 11.3272L23.3203 10.664Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19081_1040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRestaurant);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/restaurant.2d362f78ee2600adeb9afe7dedc98811.svg";